import React, { RefObject } from 'react';
import { usePageScroll } from './usePageScroll';
import { PageScrollProgressBarStyles } from '@dealstack/frontend/shared/components/PageScrollProgressBar/PageScrollProgressBar.styles.tsx';

interface Props {
	scrollContainerRef?: RefObject<HTMLElement>;
}

export const PageScrollProgressBar = ({ scrollContainerRef }: Props) => {
	const scrollPercentage = usePageScroll(scrollContainerRef);

	return (
		<PageScrollProgressBarStyles>
			<div className="bar" style={{ width: `${scrollPercentage}%` }}></div>
		</PageScrollProgressBarStyles>
	);
};
